// src/theme/components/cardStyles.js
const cardStyles = (theme) => {
  return {
    // Add this return statement
    MuiCard: {
      styleOverrides: {
        root: {
            boxShadow: theme.shadows[4],
          variants: [
            {
              props: {
                variant: "outlined",
            },
              style: {
                borderWidth: {
                  xs: "2px", // Thinner borders on mobile
                  sm: "3px",
                  md: "5px", // Original border width for larger screens
                },
                transition: theme.transitions.create(["border-width"], {
                  duration: theme.transitions.duration.standard,
                }),
                '&:hover': {
                    boxShadow: theme.shadows[6],
                }
              },
            },
          ],
        },
      },
    },
  }; // Close the return statement
};

export default cardStyles;
